import React from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {Space} from 'antd';
import {StyledBudgetDetails, StyledBudgetDetailsTable} from './StyledBudgetDetails';
import {budgetHelpers, dateHelpers, vendorsHelpers} from '../../../../utils/helpers';

const BudgetDetails = ({
  budget,
  ...rest
}) => {
  const [t] = useTranslation('main');

  const budgets = useSelector(state => state.budget?.budgets || []);

  const isPurchaseOrder = budgetHelpers.isPurchaseOrderBudget(budget);

  const details = [
    {
      key: 'procurement_type',
      label: t('procurementType'),
      value: budget?.procurement_type && t(`budgetProcurementTypes.${budget.procurement_type}`),
    },
    {
      key: 'creation_date',
      label: t('creationDate'),
      value: budget?.created_at ? dateHelpers.getDateFromISO(budget?.created_at, 'DD MMM YYYY') : '',
    },
    {
      key: 'owner',
      label: `${t('Budget')} ${t('owner')}`,
      value: (
        <Space size='small'>
          {budgetHelpers.getOwnerWithName(budget?.reported_by)}
        </Space>
      )
    },
    {
      key: 'budget',
      label: t('Budget'),
      value: budgetHelpers.getBudgetLabel(budgets, budget?.budget_id),
    },
    isPurchaseOrder && {
      key: 'vendor',
      label: t('vendor'),
      value: vendorsHelpers.getVendorNameWithLink({ name: budget?.vendor_name, id: budget?.vendor_id }),
    },
    {
      key: 'cost_center',
      label: t('costCenter'),
      value: budget?.cost_centers?.[0],
    },
    {
      key: 'expense_category',
      label: `${t('expense')} ${t('category')}`,
      value: budget?.expense_category,
    },
    {
      key: 'status',
      label: t('status'),
      value: budgetHelpers.getBudgetStatusMark(budget)
    },
    {
      key: 'collaborators',
      label: t('collaborators'),
      value: budgetHelpers.getUsersList(budget?.collaborators)
    }
  ].filter(Boolean);

  return (
    <StyledBudgetDetails {...rest}>
      <StyledBudgetDetailsTable data={details} />
    </StyledBudgetDetails>
  );
}

BudgetDetails.propTypes = {
  budget: PropTypes.object,
}

export default BudgetDetails;
